export default {
  'Start at': 'Başlangıç',
  'Set to current time': 'Geçerli süreye ayarla',
  'Audio volume': 'Ses seviyesi',
  'Video volume': 'Video seviyesi',
  'Trim audio': 'Sesi kırp',
  'Audio will end with the video': 'Ses video ile sona erecek.',
  'Trim': 'Kırp',
}